import { render, staticRenderFns } from "./DocumentTextBox.vue?vue&type=template&id=ae97a47a"
import script from "./DocumentTextBox.vue?vue&type=script&lang=ts"
export * from "./DocumentTextBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports